"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var _getDateDifference = _interopRequireDefault(require("./utils/getDateDifference"));

var _dateUnits = require("./constants/dateUnits");

var _default = {
  getCreateDates: function getCreateDates() {
    return (0, _userInfo.default)().then(function (_ref) {
      var user = _ref.user,
          portal = _ref.portal;
      return {
        user: user.created_at,
        portal: portal.created_at
      };
    });
  },
  getUserAge: function getUserAge() {
    var _this = this;

    return this.getCreateDates().then(function (_ref2) {
      var user = _ref2.user;
      return {
        days: _this.getDifferenceFromToday(user, _dateUnits.DAYS),
        weeks: _this.getDifferenceFromToday(user, _dateUnits.WEEKS),
        months: _this.getDifferenceFromToday(user, _dateUnits.MONTHS),
        years: _this.getDifferenceFromToday(user, _dateUnits.YEARS)
      };
    });
  },
  getPortalAge: function getPortalAge() {
    var _this2 = this;

    return this.getCreateDates().then(function (_ref3) {
      var portal = _ref3.portal;
      return {
        days: _this2.getDifferenceFromToday(portal, _dateUnits.DAYS),
        weeks: _this2.getDifferenceFromToday(portal, _dateUnits.WEEKS),
        months: _this2.getDifferenceFromToday(portal, _dateUnits.MONTHS),
        years: _this2.getDifferenceFromToday(portal, _dateUnits.YEARS)
      };
    });
  },
  getDifferenceFromUserCreated: function getDifferenceFromUserCreated(timestamp) {
    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _dateUnits.DAYS;
    return this.getCreateDates().then(function (_ref4) {
      var user = _ref4.user;
      return (0, _getDateDifference.default)(user, timestamp, unit);
    });
  },
  getDifferenceFromPortalCreated: function getDifferenceFromPortalCreated(timestamp) {
    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _dateUnits.DAYS;
    return this.getCreateDates().then(function (_ref5) {
      var portal = _ref5.portal;
      return (0, _getDateDifference.default)(portal, timestamp, unit);
    });
  },
  getDifferenceFromToday: function getDifferenceFromToday(timestamp) {
    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _dateUnits.DAYS;
    var today = Date.now();
    return (0, _getDateDifference.default)(today, timestamp, unit);
  },
  getUserCreatedAfter: function getUserCreatedAfter(timestamp) {
    return this.getDifferenceFromUserCreated(timestamp, _dateUnits.MILLISECONDS).then(function (diff) {
      return diff >= 0;
    });
  },
  getUserCreatedBefore: function getUserCreatedBefore(timestamp) {
    return this.getUserCreatedAfter(timestamp).then(function (isAfter) {
      return !isAfter;
    });
  },
  getPortalCreatedAfter: function getPortalCreatedAfter(timestamp) {
    return this.getDifferenceFromPortalCreated(timestamp, _dateUnits.MILLISECONDS).then(function (diff) {
      return diff >= 0;
    });
  },
  getPortalCreatedBefore: function getPortalCreatedBefore(timestamp) {
    return this.getPortalCreatedAfter(timestamp).then(function (isAfter) {
      return !isAfter;
    });
  }
};
exports.default = _default;
module.exports = exports.default;